export const FETCH_REPOS = 'FETCH_REPOS';
export const UPDATE_REPOS = 'UPDATE_REPOS';
export const FETCH_REPOS_FAILURE = 'FETCH_REPOS_FAILURE';
export const UPDATE_USERNAME = 'UPDATE_USERNAME';
export const UPDATE_SEARCH_KEYWORD = 'UPDATE_SEARCH_KEYWORD';
